<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="bookings"
      :items-per-page="200"
      hide-default-footer
      calculate-widths
    >
      <template v-slot:item.candidate="{ item }">{{ item.candidate.name }}</template>
      <template v-slot:item.client="{ item }">{{ item.client.name }}</template>
      <template v-slot:item.site="{ item }">{{ item.site.city }}</template>
      <template v-slot:item.amount="{ item }">{{ toCurrency(item.amount) }}</template>
      <template v-slot:item.wage="{ item }">{{ toCurrency(item.wage) }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment, { min } from "moment";

export default {
  props: {
    bookings: Array
  },
  data() {
    return {
      headers: [
        {
          text: "Candidate",
          value: "candidate",
          sortable: false
        },
        {
          text: "Client",
          value: "client",
          sortable: false
        },
        {
          text: "Role",
          value: "role",
          sortable: false
        },
        {
          text: "Rate",
          value: "rate",
          sortable: false
        },
        {
          text: "Location",
          value: "site",
          sortable: false
        },
        {
          text: "Extra Info",
          value: "info",
          sortable: false
        },
        { text: "Hours", value: "hours", sortable: false, align: "center" },
        { text: "Wage/Hr", value: "wage", sortable: false, align: "center" },
        { text: "Amount", value: "amount", sortable: false, align: "end" }
      ]
    };
  },
  computed: {},
  methods: {
    toCurrency(val) {
      return "£" + val.toFixed(2);
    }
  },
  mounted() {}
};
</script>